// extracted by mini-css-extract-plugin
module.exports = {"block":"layout4_block__22YVq","blockTeacher":"layout4_blockTeacher__1yK3m","col":"layout4_col__3tsIc"};